import { supportedText } from "./lianxi-yufa-supported-text.js";
import type { ItemHelp } from "../fuxi/yufa-practice.js";
import { yufaPart } from "./lianxi-yufa-item.js";
import { teachingOn } from "./lianxi-yufa-teaching.js";

/** Keep revealed clues visible when a question returns or a saved exercise resumes. */
export function showHelp(form: HTMLFormElement, help: ItemHelp): void {
  const hints = teachingOn(form)?.hints ?? [];
  const shown = yufaPart(form, "hints");
  if (shown !== undefined) {
    if (shown.children.length > help.hints) {
      shown.replaceChildren();
    }
    for (const hint of hints.slice(shown.children.length, help.hints)) {
      const line = document.createElement("p");
      supportedText(form, line, hint);
      shown.append(line);
    }
  }
  const button = yufaPart(form, "help");
  if (button !== undefined) {
    button.hidden =
      help.shown === true || form.dataset["cbYufaAnswered"] !== undefined;
    button.textContent =
      help.hints < hints.length
        ? `Hint ${String(help.hints + 1)} of ${String(hints.length)}`
        : "Show checked answer";
  }
  if (help.shown === true) {
    const why = yufaPart(form, "why");
    if (why !== undefined) {
      why.hidden = false;
    }
  }
}

/** After the last reviewed hint, the same control reveals the checked answer. */
export function nextHelp(
  form: HTMLFormElement,
  before: ItemHelp,
): { help: ItemHelp; action: "hint" | "answer" } {
  const hints = teachingOn(form)?.hints?.length ?? 0;
  return before.hints < hints
    ? { help: { ...before, hints: before.hints + 1 }, action: "hint" }
    : { help: { ...before, answer: true, shown: true }, action: "answer" };
}
